export const environment = {
    production: true,
    // api_url: 'https://api.savzo.com/api/backoffice',
    api_url: 'https://api.savso.es/api/backoffice',
    card_payment_notification_url: 'https://office.savso.es',
};
